<template>
  <div>
    <vs-progress v-if="isLoading" indeterminate color="primary" />
    <validate-replacement-kit
      :next="next"
      :kitId.sync="kitId"
      :userId.sync="userId"
      :isLoading.sync="isLoading"
      v-if="step === 1 || step === 2"
    />
    <replacement-kit-form
      :next="next"
      :kitId.sync="kitId"
      :userId.sync="userId"
      :isLoading.sync="isLoading"
      :replacementDetails.sync="replacementDetails"
      v-if="step === 2"
    />
    <replacement-details
      :next="next"
      :replacementDetails.sync="replacementDetails"
      v-if="step === 3"
    />
  </div>
</template>

<script>
import ValidateReplacementKit from "@/views/dna/components/ValidateReplacementKit";
import ReplacementKitForm from "@/views/dna/components/ReplacementKitForm";
import ReplacementDetails from "@/views/dna/components/ReplacementDetails";

export default {
  components: {
    ValidateReplacementKit,
    ReplacementKitForm,
    ReplacementDetails
  },
  data() {
    return {
      isLoading: false,
      step: 1,
      kitId: null,
      userId: null,
      replacementDetails: null
    }
  },
  methods: {
    next(reset) {
      if(reset) return this.step = 1;
      this.step++;
    }
  }
}
</script>
